<template>
  <Modal :title="'Aggiungi appuntamento'" :openModal="open" @close="$emit('close')" @success="saveAppointment()" :loading="loadingSave" style="width: 100%; padding: 30px;">
    <div class="columns is-multiline">

      <div class="column is-12-mobile is-6-tablet is-4-desktop">
        <div class="field">
          <InputSelect
            name="Occupante"
            v-model="deadline.occupant"
            :options="[]"
            :disabled="true"
            id="_id"
            track-by="_id"
            :custom-label="$clientName"
          >
            <a class="button is-warning" :href="deadline.occupant ? '/clienti/'+deadline.occupant._id : 'javascript:void(0)'"><font-awesome-icon icon="user" class="m-0" /></a>
          </InputSelect>
        </div>
      </div>

      <div class="column is-12-mobile is-6-tablet is-4-desktop">
        <InputSelect
          name="Luogo"
          v-model="deadline.place_occupant"
          :options="[]"
          :disabled="true"
          id="_id"
          track-by="_id"
          :custom-label="$placeName"
        >
          <a class="button is-warning" :href="deadline.place_occupant ? '/luoghi/'+deadline.place_occupant._id : 'javascript:void(0)'"><font-awesome-icon icon="building" class="m-0" /></a>
        </InputSelect>
      </div>

      <div class="column is-12-mobile is-6-tablet is-4-desktop">
        <InputSelect
          name="Impianto"
          v-model="deadline.system"
          :options="[]"
          :disabled="true"
          id="_id"
          track-by="_id"
          label="name"
        >
          <a class="button is-warning" :href="deadline.system ? '/impianti/'+deadline.system._id : 'javascript:void(0)'"><font-awesome-icon icon="temperature-arrow-up" class="m-0" /></a>
        </InputSelect>
      </div>

      <div class="column is-12-mobile is-6-tablet is-4-desktop">
        <InputSelect
          name="Tipologia appuntamento"
          v-model="type"
          :options="$store.state.operation_types.filter(({ maintenance }) => maintenance).map(({ name }) => name)"
          :disabled="!$store.getters.amAdmin"
        />
      </div>

    </div>

    <WeekCalendar @newAppointment="appointments = [$event]" :canCreate="true" :canEdit="false" />
  </Modal>
</template>

<script>
export default {
  props: ['deadline', 'open'],

  emits: ['saved', 'close'],

  data() {
    return {
      appointments: [],
      newOperation: {},
      loadingSave: false,

      type: null
    }
  },

  methods: {
    saveAppointment() {
      if (!this.type) {
        alert('Tipologia appuntamento mancante!')
        return
      }

      if (!this.appointments[0]) {
        alert('Non hai selezionato nulla dal calendario!')
        return
      }

      const self = this
      this.loadingSave = true

      this.newOperation = {
        client: this.deadline.client,
        occupant: this.deadline.occupant,
        place: this.deadline.place_occupant,
        implant: this.deadline.system,
        revision: this.deadline._id,
        type: this.type,
        reception_date: new Date().toDateInputValue()
      }

      /*if (this.deadline.stamp) {
        this.newOperation.type = 'Manutenzione + bollino'
      } else {
        this.newOperation.type = 'Manutenzione'
      }*/

      this.newOperation.appointment_date = this.appointments[0].appointment_date,
      this.newOperation.appointment_start = this.appointments[0].appointment_start,
      this.newOperation.appointment_end = this.appointments[0].appointment_end,
      this.newOperation.operators = this.appointments[0].operators[0]

      this.$http.post('/operation', {...this.newOperation})
      .then(function (response) {
        const id_operation = response.data._id

        self.loadingSave = false
        self.$emit('saved', id_operation)
        self.newOperation = {}
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loadingSave = false
      })
    }
  }
}
</script>